import type {VoidFunctionComponent} from "react";
import React from "react";
import "./SongCard.scss";
import {FontIcon} from "../FontIcon";
import {useAppSelector} from "../../../redux/hooks";
import {NavLink} from "react-router-dom";
import {deviceStore} from "../../../redux/device/deviceStore";

export interface ISongCard {
  songId: number;
  thumbnailUrl: string;
  name: string;
  artistName: string;
  hasVideo: boolean;
  lessonCount: number;
  useClassName?: string;
}

export function getSongCardUrl(songId: number): string {
  return `/songs/${songId}`;
}

export const SongCard: VoidFunctionComponent<ISongCard> = ({
  songId,
  thumbnailUrl,
  name,
  useClassName,
  artistName,
  lessonCount,
  hasVideo,
}) => {
  const isMobile = useAppSelector(deviceStore.getDeviceIsMobile);
  let lessonCountLabel = isMobile && hasVideo ? `${lessonCount} arrgmt` : `${lessonCount} arrangement`;
  if (lessonCount > 1) {
    lessonCountLabel += `s`;
  }
  return (
    <NavLink className={`${useClassName} songCard`} to={getSongCardUrl(songId)}>
      <img className={`songArt`} src={thumbnailUrl} alt={""} />
      <span className={`songTitle`}>{name}</span>
      <span className={`arrangements`}>{lessonCountLabel}</span>
      <span className={`artistName`}>{artistName}</span>
      {hasVideo ? <FontIcon icon={"icon-video-tutorial-solid"} ariaLabel={'Includes video'} /> : null}
    </NavLink>
  );
}
